import { fetchNaniexpert } from "@/apis/naniexpert/base";
import type {
  GetUserRecordsCountResponse,
  CheckUserUsagePeriodRequest,
} from "@/types/apis/naniexpert";

export const getUserRecordsCount = (): Promise<GetUserRecordsCountResponse> => {
  const useType = "AI_Competency_based_QuestionGeneration";
  return fetchNaniexpert<GetUserRecordsCountResponse>({
    url: `/member/userecords/count?useType=${useType}`,
    method: "GET",
  });
};

// 檢核登入者是否為南一會員中心／教育雲之教師或編輯身分。
// 通過時 body.error === 200
// 未通過時 body.error === 403
export const checkTeacherOrEditor = (): Promise<null> =>
  fetchNaniexpert<null>({
    url: "/member/identity/teacher-or-editor/check",
    method: "GET",
  });

export const checkUserUsagePeriod = (
  body: CheckUserUsagePeriodRequest
): Promise<boolean> => {
  return fetchNaniexpert<boolean>({
    url: "/member/userecords/checkuserusageperiod",
    method: "POST",
    body,
  });
};
